import styled from "styled-components";

export const Wrapper = styled.div`
  @media screen and (max-width: 767px) {
    padding: 0;
    position: relative;
    right: 0;
    bottom: 0;
    height: max-content;
  }
  @media screen and (min-width: 768px) and (max-width: 991px) {
    ${({ mosaic, terminate }) =>
      !mosaic &&
      `
     padding: 20px 100vw 20px 20px;
   height: ${terminate ? "80px" : "130px"};
    bottom: ${terminate ? "-1px" : 0};
  `}
  }
  @media screen and (min-width: 992px) and (max-width: 1199px) {
    ${({ mosaic, terminate }) =>
      !mosaic &&
      `
         bottom: ${terminate ? "-1px" : "0"};
    padding: 20px 100vw 20px 20px;
   height: ${terminate ? "90px" : "146px"};
  `}
  }
  @media screen and (min-width: 1200px) and (max-width: 1399px) {
    ${({ mosaic, terminate }) =>
      !mosaic &&
      `
          padding: 36px 100vw 36px 36px;
          bottom: ${terminate ? "-1px" : "0"};
   height: ${terminate ? "132px" : "188px"};
  `}
  }
  position: ${({ mosaic }) => (mosaic ? "relative" : "absolute")};
  ${({ mosaic, terminate }) =>
    !mosaic &&
    `
    bottom: ${terminate ? "55px" : "0"};
     height: ${terminate ? "132px" : "187px"};
    right: -100vw;
    padding: 36px 100vw 36px 36px;
  `}
`;
